import {
  IconAd2,
  IconAlertTriangle,
  IconBell,
  IconBriefcase,
  IconBuildingStore,
  IconBus,
  IconCategory,
  IconChartBar,
  IconDeviceMobile,
  IconFileText,
  IconGavel,
  IconHistory,
  IconInbox,
  IconLayoutDashboard,
  IconLayoutSidebar,
  IconLicense,
  IconMapPin,
  IconNews,
  IconPhone,
  IconPhoto,
  IconQuestionMark,
  IconSettings,
  IconShieldLock,
  IconUsers,
  IconVideo,
  type Icon,
} from '@tabler/icons-react';

export type NavItem = { label: string; to: string; icon: Icon; perm: string };
export type NavGroup = { label: string; items: NavItem[] };

// BACKOFFICE_PLAN §2, grouped the way the newsroom works. Each item needs one permission (§3);
// staff only see what they can use.
export const NAV: NavGroup[] = [
  {
    label: 'Newsroom',
    items: [
      { label: 'Dashboard', to: '/dashboard', icon: IconLayoutDashboard, perm: 'analytics:read' },
      { label: 'Stories', to: '/articles', icon: IconNews, perm: 'articles:read' },
      { label: 'Breaking ticker', to: '/breaking', icon: IconAlertTriangle, perm: 'breaking:manage' },
      { label: 'Reels', to: '/videos', icon: IconVideo, perm: 'videos:read' },
      { label: 'Media library', to: '/media', icon: IconPhoto, perm: 'media:read' },
      { label: 'Categories & tags', to: '/taxonomy', icon: IconCategory, perm: 'taxonomy:manage' },
      { label: 'Analytics', to: '/analytics', icon: IconChartBar, perm: 'analytics:read' },
    ],
  },
  {
    label: 'Readers',
    items: [
      { label: 'Notifications', to: '/notifications', icon: IconBell, perm: 'notifications:read' },
      { label: 'Ads', to: '/ads', icon: IconAd2, perm: 'ads:read' },
      { label: 'Inbox', to: '/inbox', icon: IconInbox, perm: 'inbox:read' },
    ],
  },
  {
    label: 'Services',
    items: [
      { label: 'Directory', to: '/directory', icon: IconBuildingStore, perm: 'directory:manage' },
      { label: 'Helplines', to: '/helplines', icon: IconPhone, perm: 'helplines:manage' },
      { label: 'Transport', to: '/transport', icon: IconBus, perm: 'transport:manage' },
      { label: 'Jobs', to: '/jobs', icon: IconBriefcase, perm: 'jobs:manage' },
      { label: 'Govt schemes', to: '/schemes', icon: IconLicense, perm: 'schemes:manage' },
      { label: 'Rights', to: '/rights', icon: IconGavel, perm: 'rights:manage' },
      { label: 'Current affairs', to: '/current-affairs', icon: IconQuestionMark, perm: 'current_affairs:manage' },
      { label: 'Menu pages', to: '/menu-pages', icon: IconLayoutSidebar, perm: 'menu:manage' },
    ],
  },
  {
    label: 'Admin',
    items: [
      { label: 'Staff', to: '/staff', icon: IconUsers, perm: 'users:manage' },
      { label: 'Roles', to: '/roles', icon: IconShieldLock, perm: 'roles:manage' },
      { label: 'Pages', to: '/pages', icon: IconFileText, perm: 'pages:manage' },
      { label: 'Settings', to: '/settings', icon: IconSettings, perm: 'settings:manage' },
      { label: 'States & districts', to: '/places', icon: IconMapPin, perm: 'settings:manage' },
      { label: 'Devices', to: '/devices', icon: IconDeviceMobile, perm: 'devices:block' },
      { label: 'Audit log', to: '/audit', icon: IconHistory, perm: 'audit:read' },
    ],
  },
];

/** Where to land after sign-in: the first page this staff member can open. */
export function homePath(permissions: string[]) {
  for (const group of NAV) for (const item of group.items) if (permissions.includes(item.perm)) return item.to;
  return '/account';
}
